import p from 'prop-types';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Router } from 'react-router-dom';

const CustomBrowserRouter = ({ basename, history, children }) => {
  const historyRef = useRef(history);
  const mounted = useRef(true);

  const historyValue = historyRef.current;

  const [state, setState] = useState({
    action: historyValue.action,
    location: historyValue.location,
  });

  /*
    This prevents the 'setting state on an unmounted component error
    Do not ask me why it does that because I don't know but it works
    even tho mounted is not checked anywhere...
  */
  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  useLayoutEffect(() => {
    const unlisten = historyValue.listen((data) => {
      if (mounted.current) {
        setState(data);
      }
    });
    return () => {
      unlisten();
    };
  }, [historyValue]);

  return (
    <Router navigator={historyValue} location={state.location} navigationType={state.action} basename={basename}>
      {children}
    </Router>
  );
};

CustomBrowserRouter.propTypes = {
  basename: p.string,
  history: p.object,
};

export default CustomBrowserRouter;
